module.exports = __webpack_public_path__ + "media/images/area/food-drinks-8df85789d3c1d416e6a756ecfe478222.jpg";